import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

type Lang = 'ro' | 'ru';

interface LangCtx {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (ro: string, ru: string) => string;
}

const LanguageContext = createContext<LangCtx>({
  lang: 'ro',
  setLang: () => {},
  t: (ro) => ro,
});

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>('ro');
  const t = (ro: string, ru: string) => (lang === 'ro' ? ro : ru);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
